import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnimatedCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			attributeType: "XML",
			type: "rotate",
			dur: "1s",
			from: "0 50 50",
			to: "360 50 50",
			repeatCount: "indefinite"
		})
	})
});
export default SvgAnimatedCircle;
